import * as React from "react";

import { TextField, Typography } from "@mui/material";
import { Stack } from "@mui/material";

export default function SurveyTextField({
  question,
  QuestionAnswers,
  setQuestionAnswers,
  questionNumber,
}) {
  // console.log("QuestionAnswers", QuestionAnswers);
  // console.log("question", question);
  // console.log("questionNumber", questionNumber);

  const [value, setValue] = React.useState({
    question_type: question.question_type,
    question_id: question.id,
    notes: "",
  });

  const handleNotesChange = (event) => {
    setValue({
      ...value,
      notes: event.target.value,
    });

    setQuestionAnswers(
      QuestionAnswers?.map((question) => {
        if (question.question_id === value.question_id) {
          return {
            ...question,
            answer_id: "11000",
            question_type: "textField",
            notes: event.target.value,
          };
        } else {
          return question;
        }
      }),
    );
  };

  return (
    <Stack my={2}>
      <Typography color="primary" variant="h6">
        {questionNumber} : {question?.question}
      </Typography>
      <TextField
        margin="normal"
        id="notes"
        // label={`${questionNumber}:${question}`}
        multiline
        rows={2}
        name="notes"
        value={value.notes}
        onChange={handleNotesChange}
      />
    </Stack>
  );
}
